import { operationFlow } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function OperationTimeline() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="活动运营流程"
          title="从一场活动，到一套可持续运营机制"
          subtitle="六步闭环，让每一次活动都能沉淀可复用的运营经验。"
        />

        {/* 桌面端横向时间轴 */}
        <div className="mt-14 hidden lg:block">
          <div className="relative grid grid-cols-6 gap-3">
            {operationFlow.map((step, idx) => (
              <Reveal key={step.no} delay={idx * 90}>
                <div className="relative flex flex-col items-center text-center group">
                  <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-accent-300 text-accent-600 transition-all duration-300 group-hover:bg-accent-500 group-hover:text-background-50 group-hover:border-accent-500">
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  <div className="mt-3 text-xs font-semibold text-accent-500">{step.no}</div>
                  <div className="mt-1 text-sm font-medium text-foreground-950 leading-snug">
                    {step.title}
                  </div>
                  <div className="mt-1 text-xs text-foreground-500 leading-relaxed">{step.desc}</div>
                </div>
              </Reveal>
            ))}

            {/* 连接线 */}
            <div className="absolute top-7 left-[8%] right-[8%] h-0.5 bg-background-200">
              <div className="h-full w-full bg-gradient-to-r from-accent-400 to-secondary-400 opacity-40"></div>
            </div>
          </div>
        </div>

        {/* 移动端纵向时间轴 */}
        <div className="mt-10 lg:hidden">
          <div className="space-y-0">
            {operationFlow.map((step, idx) => (
              <Reveal key={step.no} delay={idx * 60}>
                <div className="relative flex gap-4 pb-8">
                  {idx < operationFlow.length - 1 && (
                    <div className="absolute left-7 top-14 bottom-0 w-0.5 bg-background-200"></div>
                  )}
                  <div className="relative z-10 shrink-0 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-accent-300 text-accent-600">
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  <div className="pt-2">
                    <div className="text-xs font-semibold text-accent-500">{step.no}</div>
                    <div className="mt-1 text-base font-medium text-foreground-950">{step.title}</div>
                    <div className="mt-1 text-sm text-foreground-500 leading-relaxed">{step.desc}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}